// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"assets_i18n_en_translation_json":"c6dfadc05dc824141265","assets_i18n_nl_translation_json":"5b2b796f6e5853bf388c"}[chunkId] + ".chunk.js";
};